export const headlineVersionStyles = {
    XXL: {
        title: { headingType: 'h0', as: 'h1' },
        descriptionSize: 'text-h5',
        descriptionWeight: 'font-normal',
        descriptionStyle: 'mt-xl',
    },
    XL: {
        title: { headingType: 'h1', as: 'h1' },
        descriptionSize: 'text-xl',
        descriptionWeight: 'font-light',
        descriptionStyle: 'mt-m',
    },
    L: {
        title: { headingType: 'h2', as: 'h2' },
        descriptionSize: 'text-xl',
        descriptionWeight: 'font-light',
        descriptionStyle: 'mt-m',
    },
    M: {
        title: { headingType: 'h3', as: 'h2' },
        descriptionSize: 'text-xl',
        descriptionWeight: 'font-light',
        descriptionStyle: 'mt-s',
    },
    S: {
        title: { headingType: 'h4', as: 'h2' },
        descriptionSize: 'text-xl',
        descriptionWeight: 'font-light',
        descriptionStyle: 'mt-xs',
    },
    XS: {
        title: { headingType: 'h5', as: 'h2' },
        descriptionSize: 'text-m',
        descriptionWeight: 'font-light',
        descriptionStyle: 'mt-xs',
    },
};
//# sourceMappingURL=headlineVersionStyles.js.map